import {
  HeaderItemEditType,
  HeaderItemErrorsType,
} from 'modules/stores/store/content/header/types/header-interface'

export const defaultHeaderValues: HeaderItemEditType = {
  text: '',
}

export const defaultErrors: HeaderItemErrorsType = {
  text: '',
}
